import { Button, Flex, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from "@chakra-ui/react";
import { useAppDispatch } from "../../store";
import { removeRecruiter, fetchSingleDepartment } from "../../store/slices/departments";
import { useParams } from "react-router-dom";

interface ConfirmDeleteRecruiterModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm?: () => void;
    recruiterFullName: string;
    recruiterId?: number;
    isLoading?: boolean;
    departmentId?: number;
}

export const ConfirmDeleteRecruiterModal = ({
    isOpen,
    onClose,
    onConfirm,
    recruiterFullName,
    recruiterId,
    isLoading = false,
    departmentId,
}: ConfirmDeleteRecruiterModalProps) => {
    const dispatch = useAppDispatch();
    const { id } = useParams();
    const effectiveDepartmentId = departmentId ?? (id ? Number(id) : undefined);

    const handleConfirm = () => {
        if (recruiterId && effectiveDepartmentId) {
            dispatch(removeRecruiter({
                param: {
                    department_id: effectiveDepartmentId
                },
                data: {
                    recruiter_id: recruiterId
                }
            }))
                .finally(() => {
                    if (effectiveDepartmentId) dispatch(fetchSingleDepartment(effectiveDepartmentId));
                    onClose();
                });
            return;
        }
        if (onConfirm) onConfirm();
    };
    return (
        <Modal isCentered isOpen={isOpen} onClose={onClose}>
            <ModalOverlay backdropFilter="blur(3px)" />
            <ModalContent maxW="50vw" gap="24px" px="24px" paddingTop="32px" paddingBottom="24px">
                <ModalHeader p={0}>Подтвердите удаление</ModalHeader>
                <ModalBody>
                    <Text>
                        Вы действительно хотите удалить сотрудника <b>{recruiterFullName}</b> из подразделения? Это действие нельзя отменить.
                    </Text>
                </ModalBody>
                <ModalFooter p={0} pt="8px">
                    <Flex gap="12px">
                        <Button variant="outline" onClick={onClose}>Отмена</Button>
                        <Button colorScheme="red" onClick={handleConfirm} isLoading={isLoading}>Удалить</Button>
                    </Flex>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};


